import { Card, Col, Container, Row } from "react-bootstrap";
import "../scss/invoicing-for-individuals.style.scss";
import "../scss/business-styling-component/invoicing-for-business.style.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const BusinessesWork = '/assets/png/businessesWork.webp';

export const InvoicingForBusiness = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isLaptop = window.innerWidth >= 992 && window.innerWidth < 1440;
  const steps = [
    {
      number: 1,
      title: t("REGISTER_YOUR_COMPANY"),
      desc: t("REGISTER_YOUR_COMPANY_DESC"),
    },
    {
      number: 2,
      title: t("SET_PAYMENT_TERMS"),
      desc: t("SET_PAYMENT_TERMS_DESC"),
    },
    {
      number: 3,
      title: t("QUICK_SALARY_PAYMENTS"),
      desc: t("QUICK_SALARY_PAYMENTS_DESC"),
    },
    {
      number: 4,
      title: t("COMPLETE_PAYROLL_MANAGEMENT"),
      desc: t("COMPLETE_PAYROLL_MANAGEMENT_DESC"),
    },
  ];
  return (
    <Container className=" d-flex align-items-center bg-gray-color">
      <Row className="w-100 d-flex flex-column flex-column-sm-reverse flex-lg-row align-items-stretch justify-content-center  row-padding-individuals ">
        {/* Text Column */}
        <Col md={6} xs={12} lg={6} className="d-flex flex-column justify-content-center px-0 ">
          <div style={{
            maxWidth: "684px",
            width: "100%",
          }}>
            <h2 className={`Heading_h2 ` + (isLaptop ? 'mt-0 mb-0' : 'mt-3 mb-4')}>
              {t("HOW_INVOICING_WORKS_FOR_BUSINESS")}
            </h2>
            <h6 className={`section-subtitle ` + (isLaptop ? 'mb-0' : 'mb-5')}>{t("INVOICING_FOR_BUSINESS_SUBTITLE")}</h6>
            <Card className={`bg-transparent border-0 ` + (isLaptop ? 'mt-0' : 'mt-5')}>
              {steps.map((step, idx) => (
                <div key={step.number} className="d-flex my-3 position-relative">
                  <div>
                    <div className="d-flex align-items-center justify-content-center text-dark mb-4 step-circle">
                      {step.number}
                    </div>
                    {idx < steps.length - 1 && (
                      <div className="mb-4 step-line" />
                    )}
                  </div>
                  <div className="px-2 px-sm-3 px-sm-5 d-flex align-items-start flex-column">
                    <h6 className="fw-bold step-title pr-2 mt-2 mt-sm-0">{t(step.title)}</h6>
                    <p className={`text-muted mb-0 Heading_h6 pr-0 ` + (isLaptop ? '' : 'pr-sm-5')}>{t(step.desc)}</p>
                  </div>
                </div>
              ))}
            </Card>
          </div>
        </Col>
        
        {/* Image Column */}
        <Col md={6} xs={12} lg={6} className={`d-flex px-0 half-stretch  ` + (isLaptop ? '' : 'align-items-center pt-4')}>
          <img
            src={BusinessesWork}
            alt="Mobile Invoicing"
            className="img-fluid"
            style={{
              borderRadius: "20px",
              maxHeight: "100%",  // Optional: to limit image overflow
            }}
          />
        </Col>

      </Row>
    </Container>
  );
};
